module.exports = __webpack_public_path__ + "static/media/icone-deletar.2253c48f.svg";